import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { intlModule } from '@chedri/base';

import Modal from 'components/Modal';
import ContactForm from '../forms/contacts/ContactForm';

ContactModal.propTypes = {
  contact: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  validate: PropTypes.func,
  onSuccess: PropTypes.func,
  reload:PropTypes.func,
};

ContactModal.defaultProps = {
  contact: undefined,
  show: false,
  onClose: () => undefined,
  validate: () => true,
  onSuccess: () => {},
  reload: () => {},
};

function ContactModal({ contact, show, onClose, onSuccess, validate, reload }) {
  const messages = useSelector(intlModule.selectors.getMessages);

  return (
    <Modal show={show} onHide={onClose} bsSize="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{messages.add_contact}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ContactForm contact={contact} reload={reload} onSuccess={data => onSuccess(data) || onClose(data)} validate={validate} />
      </Modal.Body>
    </Modal>
  );
}

export default ContactModal;
